export default __webpack_public_path__ + "static/media/course-2.474737b6.png";